class AuthError extends Error {
  constructor (message, errno) {
    super(message)
    this.errno = errno;
    this.name = 'AuthError'
  }
}

class NotFoundError extends Error {
  constructor (message, errno) {
    super(message)
    this.errno = errno;
    this.name = 'NotFoundError'
  }
}

class SearchError extends Error {
  constructor (message, errno) {
    super(message)
    this.errno = errno;
    this.name = 'SearchError'
  }
}

class PayError extends Error {
  constructor (message, errno) {
    super(message)
    this.errno = errno;
    this.name = 'PayError'
  }
}

// Todo: 클래스속에 상수를 집에 넣어서 정확하게 구분을 한다.
//module.exports = {
export {
  AuthError, SearchError, PayError
}
